export default __webpack_public_path__ + "static/sp-radio-6f4b5ee602f44894944fbcb81ecff3e0.png";